import Http from "../helpers/Http";

class CustomerTypeService {
  
  getCustomerTypes() {
    return Http.get("/customersTypes");
  } 
  
  newCustomerType(data) {
    return Http.post("/customersTypes", data);
  }

  updateCustomerType(data) {
    return Http.update("/customersTypes", data);
  }


}

export default new CustomerTypeService();